import { AnyAction, createReducer } from '@reduxjs/toolkit';
import {
	clearAssets,
	getAssetResolved,
	getSensorResolved,
	getSystemAssetTypes,
	getSystemAssetTypesRejected,
	getSystemAssetTypesResolved,
	setMultipleAssetRequestsStatus,
} from './actions';

import { SharedAssetState } from '../../features/AssetGrid/types/asset.types';

export const initialState: SharedAssetState = {
	assets: [],
	sensors: [],
	systemAssets: {},
	systemAssetsStatus: 'idle',
	multipleAssetRequestsStatus: 'idle',
};

interface AssetReducer {
	[x: string]: (
		state: SharedAssetState,
		action: AnyAction,
	) => SharedAssetState | undefined;
}

const reducer: AssetReducer = {
	[getAssetResolved.toString()]: (state, action) => ({
		...state,
		assets: [...state.assets, action.payload],
	}),
	[setMultipleAssetRequestsStatus.toString()]: (state, action) => ({
		...state,
		multipleAssetRequestsStatus: action.payload,
	}),
	[getSensorResolved.toString()]: (state, action) => ({
		...state,
		sensors: [...state.sensors, action.payload],
	}),
	[clearAssets.toString()]: () => ({
		...initialState,
	}),
	[getSystemAssetTypes.toString()]: state => ({
		...state,
		systemAssetsStatus: 'loading',
	}),
	[getSystemAssetTypesResolved.toString()]: (state, action) => ({
		...state,
		systemAssets: action.payload,
		systemAssetsStatus: 'success',
	}),
	[getSystemAssetTypesRejected.toString()]: state => ({
		...state,
		systemAssetsStatus: 'error',
	}),
};

export default createReducer(initialState, reducer);
